import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect } from "react";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import DashboardCommonTable from "../../components/DashboardCommonTable";
import { Col, notification } from "antd";
import { valanBillDate } from "../../components/CommanFuction/CommanFunction";

const AlertTable = React.memo(() => {
  const queryClient = useQueryClient();
  const isStale = queryClient.getQueryCache().find(["alert"])?.isStale();

  // life cycle
  useEffect(() => {
    if (isStale) {
      queryClient.invalidateQueries({ queryKey: ["alert"] });
    }
  }, []);

  // api call
  const getAlert = async ({ pageParam = 1 }) => {
    if (!pageParam) {
      return;
    }
    let response = await APICall(
      "get",
      `${EndPoints.getAlertNotification}?page=${pageParam}&limit=10`
    );
    return response?.data?.data;
  };

  const alertQuery = useInfiniteQuery({
    queryKey: ["alert"],
    queryFn: getAlert,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
    // enabled: canCall,
  });

  if (alertQuery?.error) {
    notification.error({ message: alertQuery?.error?.message });
  }

  const allData =
    alertQuery?.data?.pages?.flatMap((el) => el?.notifications) || [];

  // column
  const alertColumns = [
    {
      title: "TIME",
      dataIndex: "time",
      key: "time",
      width: "10rem",
      align: "left",
      render: (text, record) => {
        return <span>{valanBillDate(record?.createdAt, true)}</span>;
      },
    },
    {
      title: "TYPE",
      dataIndex: "type",
      key: "type",
      width: "4rem",
      align: "left",
      render: (text, record) => {
        return <span>{record?.type}</span>;
      },
    },
    {
      title: "MESSAGE",
      dataIndex: "message",
      key: "message",
      align: "left",
      // width: "30rem",
      render: (text, record) => {
        return <span>{record?.message}</span>;
      },
    },
  ];

  return (
    <Col span={24}>
      <DashboardCommonTable
        columns={alertColumns}
        dataSource={allData?.[0] ? allData : []}
        tableTitle="ALERT"
        queryKey="alert"
        isLoading={alertQuery?.isLoading}
        tradeQuery={alertQuery}
        viewMore={true}
        allowBtn={false}
      />
    </Col>
  );
});
export default AlertTable;
